import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import { addCustomer } from '../Networking/APIClient';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

const editTextStyle = {
    width: '100%'
}

export const passwordHelperTextStyle = {
    marginTop: 5,
    color: '#f44336',
    padding: 0,
}

const passwordStyle = {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
}

const repeatPasswordStyle = {
    width: '100%',
    marginTop: -5,
    marginBottom: 8,
}

let self;
let t;
let updatePage;
let openFirstDialog;

class SignUpStep1 extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;
        updatePage = props.updatePage;
        openFirstDialog = props.openFirstDialog;

        this.state = this.getInitialState(props);
    }

    getInitialState = (props) => {
        let emailValue = '';
        let passwordValue = '';

        const initialState = {
            addCustomerDialogType: '',
            okDetailedInformation: null,
            notOkErrorCode: null,
            showPassword: false,
            showRepeatPassword: false,
            value_code: {
                value: '',
                error: false,
                helperText: '',
                required: true
            },
            email: {
                value: emailValue,
                error: false,
                helperText: '',
                required: true
            },
            repeatEmail: {
                value: emailValue,
                error: false,
                helperText: '',
                required: true
            },
            password: {
                value: passwordValue,
                error: false,
                helperText: '',
                required: true
            },
            repeatPassword: {
                value: passwordValue,
                error: false,
                helperText: '',
                required: true
            }
        };
        return initialState;
    }

    onNextClicked = e => {
        e.preventDefault();

        const onOk = function onOk(bpapi_status, ok_detailed_information) {
            console.log("Ok. Status: " + bpapi_status + ". Message: " + ok_detailed_information);
            const credentials = {
                email: self.state.email.value,
                password: self.state.password.value
            };

            // An ok here means we are no longer using value code, as we have proper credentials.
            // Update usingValueCode in main:
            self.props.setUsingValueCode(false);
            self.props.setCredentials(credentials);
            openFirstDialog(bpapi_status, ok_detailed_information, credentials, self.state.value_code.value);

        };

        const onError = function onError(bpapi_status) {
            console.log("Error: " + bpapi_status);
            // We reset the state to reset error flags
            self.setState(self.getInitialState(self.props));
            openFirstDialog(bpapi_status, null, null, null);
        };

        let shouldSend = true;

        // Check that passwords match
        /*
        Note that the helper text is not actually used. The FormControl
        used by the passwords does not contain a property called helperText,
        so a FormHelperText must be used instead. However, this is shown
        above the label, and is therefore not yet implemented
        */
        if (this.state.password.value !== this.state.repeatPassword.value) {
            shouldSend = false;
            this.setState({
                password: {
                    value: this.state.password.value,
                    error: true,
                    helperText: t('passwords_must_match')
                },
                repeatPassword: {
                    value: this.state.repeatPassword.value,
                    error: true,
                    helperText: t('passwords_must_match')
                },
            });
        }

        // Check that emails match
        if (this.state.email.value !== this.state.repeatEmail.value) {
            shouldSend = false;
            this.setState({
                email: {
                    value: this.state.email.value,
                    error: true,
                    helperText: t('emails_must_match')
                },
                repeatEmail: {
                    value: this.state.repeatEmail.value,
                    error: true,
                    helperText: t('emails_must_match')
                },
            });
        }

        if (isEmpty(this.state.value_code.value)) {
            shouldSend = false;
            this.setState({
                value_code: {
                    value: '',
                    error: true,
                    helperText: t('required'),
                    required: true
                }
            });
        }

        if (isEmpty(this.state.email.value)) {
            shouldSend = false;
            this.setState({
                email: {
                    value: '',
                    error: true,
                    helperText: t('required'),
                    required: true
                }
            });
        }

        if (isEmpty(this.state.password.value)) {
            shouldSend = false;
            this.setState({
                password: {
                    value: '',
                    error: true,
                    helperText: t('required'),
                    required: true
                }
            });
        }

        // The replace part removes spaces. A space in the email will make to next ok button stick.
        if (shouldSend) {
            let email = this.state.email.value.replace(/\s/g, '')
            addCustomer(email, this.state.password.value, this.state.value_code.value, onOk, onError)
        }
    }

    onCancelClicked = e => {
        e.preventDefault();
        if (this.props.comingFromLogin) {
            updatePage('login');
        } else {
            // Set the initial state. This resets error flags etc.
            self.setState(self.getInitialState(self.props));
        }
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    handleMouseDownRepeatPassword = event => {
        event.preventDefault();
    };

    handleClickShowRepeatPassword = () => {
        this.setState(state => ({ showRepeatPassword: !state.showRepeatPassword }));
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    render() {
        const content =
            <div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.value_code.required}
                        error={this.state.value_code.error}
                        helperText={this.state.value_code.helperText}
                        id="value_code"
                        value={this.state.value_code.value}
                        label={t('value_code')}
                        onChange={this.handleChange('value_code')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.email.required}
                        error={this.state.email.error}
                        helperText={this.state.email.helperText}
                        id="email"
                        value={this.state.email.value}
                        label={t('email')}
                        onChange={this.handleChange('email')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.repeatEmail.required}
                        error={this.state.repeatEmail.error}
                        helperText={this.state.repeatEmail.helperText}
                        id="repeatEmail"
                        value={this.state.repeatEmail.value}
                        label={t('repeat_email')}
                        onChange={this.handleChange('repeatEmail')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <FormControl style={passwordStyle} required={this.state.password.required}>
                        <InputLabel htmlFor="adornment-password">{t('password')}</InputLabel>
                        <Input
                            id="adornment-password"
                            error={this.state.password.error}
                            type={this.state.showPassword ? 'text' : 'password'}
                            value={this.state.password.value}
                            onChange={this.handleChange('password')}
                            onKeyPress={e => this.onKeyPressed(e)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClickShowPassword}
                                        onMouseDown={this.handleMouseDownPassword}>
                                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <FormHelperText style={passwordHelperTextStyle} id="weight-helper-text">{this.state.password.helperText}</FormHelperText>
                    </FormControl>
                </div>
                <div>
                    <FormControl style={repeatPasswordStyle} required={this.state.repeatPassword.required}
                    >
                        <InputLabel htmlFor="adornment-repeatPassword">{t('repeat_password')}</InputLabel>
                        <Input
                            id="adornment-repeatPassword"
                            error={this.state.repeatPassword.error}
                            type={this.state.showRepeatPassword ? 'text' : 'password'}
                            value={this.state.repeatPassword.value}
                            onChange={this.handleChange('repeatPassword')}
                            onKeyPress={e => this.onKeyPressed(e)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClickShowRepeatPassword}
                                        onMouseDown={this.handleMouseDownRepeatPassword}>
                                        {this.state.showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </div>
                <div style={buttonContainerStyle}>
                    <Button
                        style={buttonStyle}
                        variant="text"
                        color="default"
                        onClick={e => this.onCancelClicked(e)}>
                        {t('cancel')}
                    </Button >
                    <Button
                        style={buttonStyle}
                        variant="contained"
                        color="primary"
                        onClick={e => this.onNextClicked(e)}>
                        {t('next')}
                    </Button >
                </div>
            </div>;

        const narrowContent =
            <div className="Login">
                <Paper className="login-content">
                    <div className="content-container-paper">
                        <div className='typography-title-container'>
                            <Typography variant="title">
                                {t('sign_up')}
                            </Typography>
                        </div>
                        <div className="typography-title-container">
                            <Typography variant="subheading">
                                {t('sign_up_information')}
                            </Typography>
                        </div>
                        {content}
                    </div>
                </Paper>
            </div>;

        const normalContent =
            <div className="content-frame">
                <Paper className="content">
                    <div className="content-container-paper">
                        <div className='typography-title-container'>
                            <Typography variant="title">
                                {t('sign_up')}
                            </Typography>
                        </div>
                        <div className="typography-title-container">
                            <Typography variant="subheading">
                                {t('sign_up_information')}
                            </Typography>
                        </div>
                        {content}
                    </div>
                </Paper>
            </div>;

        return (
            <div>
                {this.props.comingFromLogin ? narrowContent : normalContent}
            </div>
        );
    }
}

function isEmpty(value) {
    return value === '';
}


export default SignUpStep1;


// WEBPACK FOOTER //
// ./src/Pages/SignUpStep1.js